import React from 'react';
import { useProjectAccessCtx } from 'src/features/projects/ProjectAccessContext';
import WbsProgressEntryContainer from './WbsProgressEntryContainer';

export default function WbsInternalProgressEntryContainer({ projectId }: { projectId: string }) {
    const { access } = useProjectAccessCtx();

    return (
        <WbsProgressEntryContainer
            projectId={projectId}
            canEdit={true}
            variant="internal"
            editableOrgIds={access?.evEntryOrgIds ?? []}
            listTitle="Internal Weekly Progress Entry"
            listSubtitle="All WBS visible, only my ORG-assigned leaf items are editable"
        />
    );
}
